import React, { FC } from "react";
import { Autocomplete as MuiAutocomplete } from "@mui/material";

type Props = React.ComponentProps<typeof MuiAutocomplete>;

const Autocomplete: FC<Props> = (props) => {
    return <MuiAutocomplete {...props}/>
}

export default Autocomplete;